export default __webpack_public_path__ + "static/media/ActionRequired.1dc9d962.svg";